import PeopleIcon from '@material-ui/icons/People';
import { InquiryTypeCreateView } from './views/inquiry-type-create.view';
import { InquiryTypeEditView } from './views/inquiry-type-edit.view';

export default {
  create: InquiryTypeCreateView,
  edit: InquiryTypeEditView,
  icon: PeopleIcon,
};
